export default function (varName) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();

    return evaluateCssValue(raw);

    function evaluateCssValue(value) {
        if (value.startsWith("calc(")) {
            return evaluateCalc(value);
        }

        return unitToPx(value);
    }

    function unitToPx(value) {
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

        const vw = window.innerWidth;

        if (value.endsWith("rem")) {
            return parseFloat(value) * rootFontSize;
        }

        if (value.endsWith("vw")) {
            return (parseFloat(value) * vw) / 100;
        }

        if (value.endsWith("px")) {
            return parseFloat(value);
        }

        return parseFloat(value);
    }

    function evaluateCalc(expr) {
        expr = expr.trim().replace(/^calc\((.*)\)$/, "$1");

        while (expr.includes("calc(")) {
            expr = expr.replace(/calc\(([^()]+)\)/g, (_, inner) => evaluateCalc(`calc(${inner})`));
        }

        expr = expr.replace(/([\d.]+)(rem|vw|px)?/g, (_, num, unit = "") => {
            return unitToPx(num + unit);
        });

        try {
            if (!/^[\d+\-*/ ().]+$/.test(expr)) throw new Error("Unsafe expression");
            return new Function(`return (${expr})`)();
        } catch (e) {
            jdmn.log("Failed to evaluate CSS variable:", expr);
            return NaN;
        }
    }
}
